const subMenu = [
  {
    id: 1,
    title: "Masa Aktif Paket E-Payment",
    subtitle: "",
    linkTo: "pengaturanUmum.paket_epayment",
  },
  {
    id: 2,
    title: "Pengingat Masa Aktif",
    subtitle: "",
    linkTo: "pengaturanUmum.reminder-masa-aktif",
  },
  {
    id: 3,
    title: "Ambil Tanpa Lunasi",
    subtitle: "",
    linkTo: "pengaturanUmum.ambil-tanpa-lunasi",
  },
  {
    id: 4,
    title: "Pengaturan Riwayat Biaya Kasir",
    subtitle: "",
    linkTo: "pengaturanUmum.pengaturan-laporan",
  },
  {
    id: 5,
    title: "Pelunasan Invoice",
    subtitle: "",
    linkTo: "pengaturanUmum.pelunasan-invoice",
  },
  {
    id: 6,
    title: "Verifikasi WA Daftar Member",
    subtitle: "",
  },
  {
    id: 7,
    title: "Masa Aktif Cashback E-Payment",
    subtitle: "",
    linkTo: "pengaturanUmum.masa-aktif-cashback",
  },
  {
    id: 8,
    title: "Masa Aktif Poin",
    subtitle: "",
    linkTo: "pengaturanUmum.poin-active-period",
  },
  {
    id: 9,
    title: "Pengiriman WA nota",
    subtitle: "",
    linkTo: "pengaturanUmum.wa-nota",
  },
  {
    id: 10,
    title: "Pengaturan Rekomendasi",
    subtitle: "",
  },
];

export default subMenu;
